// TODO: Move renderers to folder
import { initLazyLoadedImages } from './listingImageRenderer'
import { setOpenModalButtons } from '../modals'
import { getWishlistedItemsFromPage, getHitHTML, getGiftCardTile, getTradeTile } from './listingTileUtils'
import { initTradeTile } from '../tradeChat'
import { plpTileNewsLetterSignUp } from '../newsLetterSignUp'

import setUpAddToWishlistBehaviour from '../addToWishlist'
import setMaskedUrls from '../maskedUrls'

// Last HTML written per container, so an identical re-render can be skipped.
// WeakMap rather than a data attribute: no DOM pollution, and entries disappear
// with the element.
const lastRenderedHtml = new WeakMap()

export default function renderAndEnableListingTiles (placeholderElement, hits, tileOptions = {}) {
  const wishlistedItems = getWishlistedItemsFromPage()
  // TODO: Check this again later when adding cache - we always set trade to false on recommended listing sections
  const isTradeBuyer = JSON.parse(placeholderElement.getAttribute('data-trade-buyer'))
  const isLoggedIn = JSON.parse(document.querySelector('body').getAttribute('data-logged-in'))
  const userCurrency = placeholderElement.dataset.userCurrency
  const userStatus = { isTradeBuyer, isLoggedIn }
  const hitsHtml = hits.map(hit => getHitHTML(hit, wishlistedItems, userStatus, tileOptions))

  addContentTile(tileOptions, hitsHtml, isTradeBuyer, userCurrency)
  const html = hitsHtml.join('')

  // InstantSearch renders hits on every state change — one filter click is
  // three render passes, two with identical results, each a full grid
  // teardown (the visible flicker). Skip byte-identical writes. Safe: the
  // guard is on the rendered output, so anything that changes a tile changes
  // the HTML and still writes.
  if (lastRenderedHtml.get(placeholderElement) === html) return

  lastRenderedHtml.set(placeholderElement, html)
  placeholderElement.innerHTML = html

  // Not inside addContentTile() because can't happen until all the hits (inc trade tile) are actually rendered
  if (isTradeBuyer && tileOptions.plpPage) initTradeTile()

  initLazyLoadedImages()
  setOpenModalButtons()
  setUpAddToWishlistBehaviour()
  plpTileNewsLetterSignUp()
  setMaskedUrls()

  forceGTMVisibilityTriggerToWakeUp(placeholderElement)
}

function forceGTMVisibilityTriggerToWakeUp (placeholderElement) {
  // Rui: Hack to get GTM Visibility Trigger (watching DOM changes) to wake up and continue tracking
  if (placeholderElement.hasAttribute('data-productid')) {
    placeholderElement.removeAttribute('data-productid')
  } else {
    placeholderElement.setAttribute('data-productid', '')
  }
}

function addContentTile (tileOptions, hitsHtml, isTradeBuyer, userCurrency) {
  if (tileOptions.rankingDebug) return
  if (isTradeBuyer && tileOptions.plpPage) {
    placeTileIn5thPosition(hitsHtml, getTradeTile())
  } else if (tileOptions.showValueUSPTile) {
    const signupTemplate = document.querySelector('template[data-id="content-signup-tile"]')
    if (signupTemplate) {
      placeTileIn5thPosition(hitsHtml, signupTemplate.innerHTML)
    } else if (userCurrency === 'gbp') {
      placeTileIn5thPosition(hitsHtml, getGiftCardTile())
    }
    // else: non-GBP with no signup template (e.g. user already opted in) → no content tile
  }
}

function placeTileIn5thPosition (hitsHtml, contentTile) {
  if (hitsHtml.length > 4 && contentTile) {
    hitsHtml.splice(4, 0, contentTile)
  }
}
